import axios, {AxiosInstance, AxiosResponse} from 'axios';
import {AuthResponse, CVTemplate, LoginRequest, RegisterRequest} from '../types';
import {LoginGoogleRequest} from "../types/DTOs/LoginGoogleRequest";

export class ApiService {
  protected api: AxiosInstance;

  //private static instance: ApiService | null = null;

  public constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'https://localhost:7000/api',
      timeout: 10000,
    });

    // Interceptor per aggiungere il token JWT
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Interceptor per gestire errori di autenticazione
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  private static instances = new Map<Function, ApiService>();

  public static Instance<T extends ApiService>(): T {
    if (!ApiService.instances.has(this)) {
      ApiService.instances.set(this, new this());
    }
    return ApiService.instances.get(this) as T;
  }

  // Auth endpoints
  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response: AxiosResponse<AuthResponse> = await this.api.post('/auth/register', data);
    return response.data;
  }

  async login(data: LoginRequest): Promise<AuthResponse> {
    const response: AxiosResponse<AuthResponse> = await this.api.post('/auth/login', data);
    return response.data;
  }

  async loginGoogle(data: LoginGoogleRequest): Promise<AuthResponse>{
    const response: AxiosResponse<AuthResponse> = await this.api.post('/auth/google-authenticate', data);
    return response.data;
  }

  async googleLogin(): Promise<void> {
    window.location.href = `${process.env.REACT_APP_API_URL || 'https://localhost:7000/api'}/auth/google`;
  }

  async linkedinLogin(): Promise<void> {
    window.location.href = `${process.env.REACT_APP_API_URL || 'https://localhost:7000/api'}/auth/linkedin`;
  }

  // Auth — forgot password
  async forgotPassword(email: string): Promise<{ message: string }> {
    const response: AxiosResponse<{ message: string }> = await this.api.post('/auth/forgot-password', { email });
    return response.data;
  }

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response: AxiosResponse<{ message: string }> = await this.api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  }

  // CV endpoints
  async getTemplates(): Promise<CVTemplate[]> {
    const response: AxiosResponse<CVTemplate[]> = await this.api.get('/cv/templates');
    return response.data;
  }

  // Share endpoints


  // PDF endpoints
  async generatePDF(cvVersionId: string): Promise<Blob> {
    const response: AxiosResponse<Blob> = await this.api.post(`/pdf/cv/${cvVersionId}`, {}, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export const apiService = new ApiService();
